// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"540":"b119dd6c7838a0cf","2888":"a5be2293a236ade5"}[chunkId] + ".css";
};